/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupedSessionsResponse } from '../../models/grouped-sessions-response';

export interface GetGroupedSessions$Params {
}

export function getGroupedSessions(http: HttpClient, rootUrl: string, params?: GetGroupedSessions$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupedSessionsResponse>> {
  const rb = new RequestBuilder(rootUrl, getGroupedSessions.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GroupedSessionsResponse>;
    })
  );
}

getGroupedSessions.PATH = '/sessions/grouped';
